import {createRouter, createWebHistory} from 'vue-router';
import HomePage from './components/HomePage.vue';

// let base= window.drupalSettings.idfive_calendar_client.options.base;
// if (!base.endsWith("/")) {
//     base += "/";
// }

let base = "/";

const routes = [
    {
        path: base,
        name: 'HomePage',
        component: HomePage,
    },
    {
        path: base + ':taxonomy',
        name: 'Taxonomy',
        component: HomePage,
    }
]

export const router = createRouter({
    history: createWebHistory(window.drupalSettings.idfive_calendar_client.options.base),
    routes,
});
